module.exports = __webpack_public_path__ + "img/one.0c15ba79.png";